export const role = {
	ADMINISTRATOR: "ADMINISTRATOR",
	LOCAL_ADMINISTRATOR: "LOCAL_ADMINISTRATOR",
	DEPARTMENT_EMPLOYEE: "DEPARTMENT_EMPLOYEE",
	INSTITUTION_EMPLOYEE: "INSTITUTION_EMPLOYEE",
	EXPERT: "EXPERT",
	BIDDER: "BIDDER",
	SUB_BIDDER: "SUB_BIDDER",
	VOLUNTEER: "VOLUNTEER",
	VIEWER: "VIEWER",
	AGENCY_EMPLOYEE: "AGENCY_EMPLOYEE",

	isAdministrator() {
		return sessionStorage["role"] === this.ADMINISTRATOR;
	},

	isLocalAdministrator() {
		return sessionStorage["role"] === this.LOCAL_ADMINISTRATOR;
	},

	isDepartmentEmployee() {
		return sessionStorage["role"] === this.DEPARTMENT_EMPLOYEE;
	},

	isAgencyEmployee() {
		return sessionStorage["role"] === this.AGENCY_EMPLOYEE;
	},

	isInstitutionEmployee() {
		return sessionStorage["role"] === this.INSTITUTION_EMPLOYEE;
	},

	isExpert() {
		return sessionStorage["role"] === this.EXPERT;
	},

	isBidder() {
		return sessionStorage["role"] === this.BIDDER;
	},

	isSubBidder() {
		return sessionStorage["role"] === this.SUB_BIDDER;
	},

	isVolunteer() {
		return sessionStorage["role"] === this.VOLUNTEER;
	},

	isViewer() {
		return sessionStorage["role"] === this.VIEWER;
	},
};

